import { useContext, createContext } from 'react';
import { u as useSurface } from '../SurfaceProvider/SurfaceProvider-qDGZSFCj.js';

/**
 * HasTextAncestorContext provides context information on if there is a Text component as an ancestor.
 */
const HasTextAncestorContext = /*#__PURE__*/createContext({
  size: undefined,
  color: undefined,
  weight: undefined,
  hasAncestor: false
});

/**
 * Returns whether there is a Text component as an ancestor of the component.
 */
const useHasTextAncestor = () => useContext(HasTextAncestorContext);

/**
 * Custom hook designed to abstract the parsing of the color prop and make it clearer
 * in the future how color is reconciled between themes and tokens.
 */
const useTextAncestorColor = colorProp => {
  const {
    isInverted
  } = useSurface();
  const {
    color: ancestorColor
  } = useHasTextAncestor();

  /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */
  if (isInverted) {
    return 'inverted';
  }
  return colorProp || ancestorColor || 'default';
};

/**
 * Custom hook designed to abstract the parsing of the weight prop and make it clearer
 * in the future how weight is reconciled between themes and tokens.
 */
const useTextAncestorWeight = weightProp => {
  const {
    weight: ancestorWeight
  } = useHasTextAncestor();
  return weightProp || ancestorWeight || 'regular';
};

/**
 * Custom hook designed to abstract the parsing of the size props and make it clearer
 * in the future how sizes is reconciled between themes and tokens.
 */
const useTextAncestorSize = sizeProp => {
  const {
    size: ancestorSize
  } = useHasTextAncestor();
  return sizeProp || ancestorSize || 'base';
};

export { HasTextAncestorContext as H, useHasTextAncestor as a, useTextAncestorColor as b, useTextAncestorWeight as c, useTextAncestorSize as u };
//# sourceMappingURL=HasTextAncestorContext-DP5pzSWh.js.map
